import React, { Fragment, useContext } from "react";
import Button from 'react-bootstrap/Button';
import { AuthStore } from "../../providers/auth";

function Login() {
  const [, login] = useContext(AuthStore) || [];
  return (
    <Fragment>
      <Button onClick={() => {
        login("", "");
      }}>Login</Button>      
    </Fragment>
  );
}

export default Login;